import { createStepNavigation } from '@mui/x-date-pickers/internals';
export function createRangePickerStepNavigation(parameters) {
  const {
    steps,
    rangePositionResponse
  } = parameters;
  return createStepNavigation({
    steps,
    isViewMatchingStep: (view, step) => {
      if (step.rangePosition !== rangePositionResponse.rangePosition) {
        return false;
      }
      return step.views == null || step.views.includes(view);
    },
    onStepChange: ({
      step,
      defaultView,
      setView,
      view,
      views
    }) => {
      if (step.rangePosition !== rangePositionResponse.rangePosition) {
        rangePositionResponse.setRangePosition(step.rangePosition);
      }
      const targetView = step.views == null ? defaultView : step.views.find(viewBis => views.includes(viewBis));
      if (targetView !== view) {
        setView(targetView);
      }
    }
  });
}